import React, { useState } from "react";
import {
  emailValidation,
  notEmptyValidation,
  urlValidation,
  validateUserPassword,
} from "../../../functions/validation";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const InputPassword = (props) => {
  const {
    placeholder,
    value,
    onChange,
    name,
    errorText,
    validationOff,
    height,
  } = props;

  const [error, seterror] = useState(null);
  const [passwordVisible, setpasswordVisible] = useState(false);

  function checkValidation() {
    if (!validationOff && !validateUserPassword(value)) {
      seterror(errorText ? errorText : "Please enter a valid password");
    }
  }

  return (
    <div className={`input-text ${error ? "input-error" : ""}`}>
      <div className={`input ${height ? "height" : ""}`}>
        <input
          type={!passwordVisible ? "password" : "text"}
          placeholder={error ? error : placeholder}
          value={value}
          onChange={(e) => {
            seterror(null);
            onChange(e);
          }}
          name={name}
          onBlur={checkValidation}
        />
        {passwordVisible ? (
          <VisibilityIcon onClick={() => setpasswordVisible(false)} />
        ) : (
          <VisibilityOffIcon onClick={() => setpasswordVisible(true)} />
        )}
      </div>
    </div>
  );
};

export default InputPassword;
